import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

export default function Newsletter() {
	const { i18NJson: i18n } = useStaticQuery(graphql`
		query {
			i18NJson {
				ui {
					newsletterRegisterTitle
					newsletterRegisterSubmit
				}
			}
		}
	`);

	return (
		<section className="section-block newsletter">
			<div className="container">
				<header>
					<h2>{i18n.ui.newsletterRegisterTitle}</h2>
				</header>
				<form
					id="subForm"
					action="https://elearnis.createsend.com/t/j/s/vtydjl/"
					method="post"
				>
					<div className="row">
						<div className="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
							<div className="input-group">
								<label htmlFor="fieldEmail" className="sr-only">
									e-mail :{' '}
								</label>
								<input
									id="fieldEmail"
									className="form-control"
									name="email"
									type="email"
									placeholder="Votre adresse e-mail"
									required
								/>
								<span className="input-group-btn">
									<button
										className="btn btn-secondary"
										type="submit"
									>
										{i18n.ui.newsletterRegisterSubmit}
									</button>
								</span>
							</div>
						</div>
					</div>
				</form>
			</div>
		</section>
	);
}
